import React from "react";
import { Navigate } from "react-router-dom";

// Hotfix Pricing-Consolidation (10.02.2026) — Boardroom-CoS-Directive:
// Die alte /dashboard/abo-Oberfläche darf im aktiven User-Flow nicht
// mehr rendern. Zentrale Pricing-Seite ist /pricing. Damit bestehende
// Deep-Links, Header-Nav, Upsell-Toasts und alte Bookmarks weiterhin
// funktionieren, bleibt die Route technisch erhalten und leitet
// serverseitig-transparent auf /pricing um.
//
// Alle Preise, Produktbedingungen und Checkout-Ziele bleiben unverändert.
// Die Checkout-Trigger (window.location.href = checkout_urls.monthly/…)
// laufen jetzt zentral aus /pricing (via GET /api/pricing/pro-solo).
export default function DashboardAbo() {
  return <Navigate to="/pricing" replace />;
}
